"use strict";

define('model/meeting.document',['./base'], function (Model) {
  var MeetingDocument = Model.extend({
    virtual: {
      'documentId': Model.createKeyPathVirtual('document.id'),
      'templateType': Model.createKeyPathVirtual('document.templateType')
    },
    childModels: {
      'document': 'Document'
    },
    toJSON: function toJSON() {
      var data = Model.prototype.toJSON.apply(this, arguments);
      delete data.id;
      return data;
    }
  }, {
    createWithDocumentId: function createWithDocumentId(documentId) {
      return new MeetingDocument().set('document', {
        id: documentId
      });
    }
  });
  return MeetingDocument;
});

